import React from 'react';
import classNames from 'classnames';

interface AddSeriesContentProps {
  classname?: string;
  children?: React.ReactNode;
}

const AddSeriesContent: React.FC<AddSeriesContentProps> = ({ classname, children }) => {
  return <div className={classNames('add-series-content', classname)}>{children}</div>;
};

export default AddSeriesContent;
